import { render, staticRenderFns } from "./BudgetCashType.vue?vue&type=template&id=58856465&"
import script from "./BudgetCashType.vue?vue&type=script&lang=js&"
export * from "./BudgetCashType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BudgetCashType.vue"
export default component.exports